import { query, run } from '../db'
import { DEFAULT_SETTINGS, state } from './state'

export async function loadSettings() {
  const rows = await query('SELECT key, value FROM settings')
  const loaded = { ...DEFAULT_SETTINGS }
  for (const { key, value } of rows) {
    try {
      loaded[key] = JSON.parse(value)
    } catch {
      loaded[key] = value
    }
  }
  state.settings = loaded
  return loaded
}

export async function setSetting(key, value) {
  state.settings[key] = value
  await run(
    'INSERT INTO settings (key, value) VALUES (?, ?) ON CONFLICT(key) DO UPDATE SET value = excluded.value',
    [key, JSON.stringify(value)],
  )
}

/**
 * Privacy mode, as cycled from the header:
 *   off     everything visible
 *   on      the figures that describe the whole account are hidden — balance,
 *           daily allowance, month totals, savings — while the ledger reads
 *           normally, so you can still work in front of someone
 *   strict  no amount is drawn anywhere
 */
export const PRIVACY_MODES = ['off', 'on', 'strict']

export function cyclePrivacy() {
  const at = PRIVACY_MODES.indexOf(state.settings.privacy ?? 'off')
  return setSetting('privacy', PRIVACY_MODES[(at + 1) % PRIVACY_MODES.length])
}

export async function setSettings(patch) {
  for (const [key, value] of Object.entries(patch)) await setSetting(key, value)
}
